import { SocketActions } from '@store/socketSaga'
import { put, select } from 'redux-saga/effects'

import { authSelector } from '@/hooks/useAuth'
import type { AuthState } from '@/types'
import { InternalActions, type LocksActions } from '../actions'

export function* lockId({
  payload: { id },
}: ReturnType<typeof LocksActions.lockId>) {
  const auth: AuthState = yield select(authSelector)

  const initiatorId = auth.id || 'unknown'

  yield put(
    SocketActions.emit({
      // todo: use separate event for locks and store locks in redis
      eventName: 'sync',
      payload: [InternalActions.setLock({ initiatorId, id })],
    })
  )
}
